import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class TransactionMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TransactionMetaModule,
            providers: [
                providePageMeta({
                    title: 'Transactions',
                    translationKey: 'page_transactions',
                    routerLink: '/queues/:id/transactions',
                    icon: 'list-ol',
                    permission: 'Transactions.View',
                    type: 'Breadcrumb',
                    parentRoute: '/queues',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Review Requests',
                    translationKey: 'page_review_requested',
                    routerLink: '/review-requested/:id',
                    svgIcon: 'uipath:review',
                    permission: 'Transactions.View',
                    type: 'SubMenu',
                    category: PageCategory.Tenant,
                    parentRoute: '/queues',
                    scope: PageScope.Folder,
                }),
            ],
        };
    }
}
